import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FormattedMarkdown } from '@/components/formatted-markdown';
import { KeyboardAwareScrollView } from '@/components/with-keyboard-aware';
import { TouchableOpacity, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface Props {
  markdownTemplate: string;
  onViewAdditionalTerms: () => void;
}

export const PadAgreement: React.FC<Props> = ({
  markdownTemplate,
  onViewAdditionalTerms,
}) => {
  const [styles] = useStyles();
  const { bottom } = useSafeAreaInsets();

  return (
    <View style={styles.container}>
      <KeyboardAwareScrollView
        contentContainerStyle={{ paddingBottom: bottom + 80 }}
        keyboardDismissMode="on-drag"
        style={styles.contentContainer}
      >
        <View style={styles.contentWrapper}>
          <View style={styles.agreementBox}>
            <FormattedMarkdown markdown={markdownTemplate} />
            <TouchableOpacity
              onPress={onViewAdditionalTerms}
              style={styles.additionalTermsContainer}
            >
              <Typography variant="paragraph-base-600">
                {`${i18n.t('view_additional_terms_and_conditions')} >`}
              </Typography>
            </TouchableOpacity>
          </View>
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
};

const useStyles = createStyles(() => ({
  additionalTermsContainer: {
    marginTop: 16,
  },
  agreementBox: {
    borderRadius: 8,
    padding: 16,
  },
  container: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
  },
  contentWrapper: {
    paddingHorizontal: 16,
  },
}));
